import React, { useState, useEffect } from 'react'; 
import axios from 'axios'; 
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 
import * as XLSX from 'xlsx'; 
import { saveAs } from 'file-saver';
import { useShop } from '../context/ShopContext';
import { FaSpinner } from 'react-icons/fa';
import Sidebar from './Sidebar';
import EmptyState from "./EmptyState";
import { useLocation, useNavigate } from "react-router-dom";


const StockManagementReport = () => {


  const navigate = useNavigate(); // For navigation
  const [stockData, setStockData] = useState(null); // Initial state is null (no data fetched yet)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [language, setLanguage] = useState('English');
  const [entriesPerPage, setEntriesPerPage] = useState(10); 
  const [currentPage, setCurrentPage] = useState(1); 
  const { userId } = useShop();
  const [shopId, setShopId] = useState(null);
  const [tokenString, setToken] = useState(null);
  const [shopName,setshopName] = useState(null);


  console.log("Shopidstock:",shopId)





  const showToast = (message, type = "error") => {
    toast.dismiss(); // Dismiss any existing toast before showing a new one
  
    console.log("Toast Type:", type); // Debugging log to check type value
  
    if (type.toLowerCase() === "error") {
      toast.error(message);
    } else if (type.toLowerCase() === "success") {
      toast.success(message);
    } else {
      console.warn("Invalid toast type:", type);
    }
  };





     useEffect(() => {
       const savedShopId = localStorage.getItem("shopId");
       const savedTokenString = localStorage.getItem("tokenString");
       const savedshopName =localStorage.getItem("shopName");
     
       console.log("savedShopId: ",savedShopId)
   
       if ( savedTokenString ) {
         setShopId(savedShopId);
         setToken(savedTokenString);
         setshopName(savedshopName);
       } else {
         showToast("Please log in first!","error");
         navigate("/Signin"); // Redirect to login page if not logged in
       }
     }, [navigate]);


  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]; 
    setFromDate(today);
    setToDate(today);
  }, []);

  const fetchStockData = async () => {
    setLoading(true);
    setError(null);

    const typeId = language === 'English' ? 1 : 2;

    try {
      const response = await axios.post(
        'https://winenew.sipstocks.in/api/Liquor/GetProductSummary',
        {
          shopId: shopId,
          fromDate: new Date(fromDate).toISOString(),
          toDate: new Date(toDate).toISOString(),
          typeId: typeId,
        },
        {
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
          },
        }
      );

      console.log("Report data:", response);
      if (response.data && response.data.data) {
        setStockData(response.data.data);
      } else {
        setStockData([]); // Set stockData as an empty array if no data is returned
      }
    } catch (err) {
      console.error('Error fetching stock data:', err);
      setError('Failed to fetch stock data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!fromDate || !toDate) {
      setError('Please select both from and to dates.');
      return;
    }
    fetchStockData(); // Call API on button click
  };

//   const exportToExcel = () => {
//     if (!stockData || stockData.length === 0) {
//      showToast("No data to export!","error");
//       return;
//     }
  
//     try {
//       // Convert stock data to worksheet
//       const exportData = stockData.map((item, index) => ({
//         "S.No.": index + 1,
//         "Product Name": item.pName || "N/A",
     
//         "Variant": item.packing,
//         "Opening Stock": item.openingStock || 0,
//         "Received": item.rece,
//         "Transfer": item.trans,
//         "Total": (item.openingStock || 0) + (item.rece || 0) - (item.trans || 0),
//         "Closing Stock": item.closingStock || 0,
//         "Sales": item.sales || 0,
//         "Rate": item.mrp,
//         "Amount": (item.sales || 0) * (item.mrp || 0),
      
       
//       }));
  
//       // Total Row
//       exportData.push({
//         "S.No.": "Total",
//         "Product Name": "",
    
//         "Variant": "",
//         "Opening Stock": stockData.reduce((sum, item) => sum + (item.openingStock || 0), 0),
       
//         "Received": stockData.reduce((sum, item) => sum + (item.rece || 0), 0),
//         "Transfer": stockData.reduce((sum, item) => sum + (item.trans || 0), 0),
//         "Closing Stock": stockData.reduce((sum, item) => sum + (item.closingStock || 0), 0),
//         "Total": stockData.reduce((sum, item) => sum + ((item.openingStock || 0) + (item.rece || 0) - (item.trans || 0)), 0),
//         "Sales": stockData.reduce((sum, item) => sum + (item.sales || 0), 0),
//         "Rate": stockData.reduce((sum, item) => sum + (item.mrp || 0), 0),
//         "Amount": "₹ " + stockData.reduce((sum, item) => sum + ((item.sales || 0) * (item.mrp || 0)), 0),
       
//       });
  
//       // const worksheet = XLSX.utils.json_to_sheet(exportData);
//       // const workbook = XLSX.utils.book_new();
//       // XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");



//  const worksheet = XLSX.utils.json_to_sheet(exportData);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");



//   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//       const data = new Blob([excelBuffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

  
//       // Generate Excel file as a Blob
//       // const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//       // const data = new Blob([excelBuffer], {
//       //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       // });
  
//       // Detect old iOS versions (iOS 12.5 and below)
//       const isOldIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.Promise;
  
//       if (isOldIOS) {
//         // Convert file to base64 URI for download in older iOS versions
//         const reader = new FileReader();
//         reader.onload = function () {
//           const link = document.createElement("a");
//           link.href = reader.result;
//           link.download = "Stock_Report.xlsx";
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);
//         };
//         reader.readAsDataURL(data);
//       } else {
//         // Use FileSaver for modern devices (iOS 13+, Android, Windows, Mac)
//         saveAs(data, "Stock_Report.xlsx");
//       }
  
//       showToast("Data exported successfully!","success");
//       setTimeout(() => window.location.reload(), 2000);
//     } catch (error) {
//       console.error("Error exporting data:", error);
//       showToast("Failed to export data.","error");
//     }
//   };
  
const exportToExcel = () => {
  if (!stockData || stockData.length === 0) {
    showToast("No data to export!", "error");
    return;
  }

  try {
    const exportData = stockData.map((item, index) => ({
      "S.No.": index + 1,
      "Product Name": item.pName || "N/A",
      "Variant": item.packing,
      "Opening Stock": item.openingStock || 0,
      "Received": item.rece || 0,
      "Transfer": item.trans || 0,
      "Total": (item.openingStock || 0) + (item.rece || 0) - (item.trans || 0),
      "Closing Stock": item.closingStock || 0,
      "Sales": item.sales || 0,
      "Rate": item.mrp || 0,
      "Amount": (item.sales || 0) * (item.mrp || 0),
    }));

    // Add totals row
    exportData.push({
      "S.No.": "Total",
      "Product Name": "",
      "Variant": "",
      "Opening Stock": stockData.reduce((sum, item) => sum + (item.openingStock || 0), 0),
      "Received": stockData.reduce((sum, item) => sum + (item.rece || 0), 0),
      "Transfer": stockData.reduce((sum, item) => sum + (item.trans || 0), 0),
      "Total": stockData.reduce((sum, item) => sum + ((item.openingStock || 0) + (item.rece || 0) - (item.trans || 0)), 0),
      "Closing Stock": stockData.reduce((sum, item) => sum + (item.closingStock || 0), 0),
      "Sales": stockData.reduce((sum, item) => sum + (item.sales || 0), 0),
      "Rate": "", // No total for rate
      "Amount": stockData.reduce((sum, item) => sum + ((item.sales || 0) * (item.mrp || 0)), 0),
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Report");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(data, "Stock_Report.xlsx");
    showToast("Data exported successfully!", "success");
  } catch (error) {
    console.error("Export error:", error);
    showToast("Failed to export data.", "error");
  }
}
  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page when the entries per page is changed
  };

  const paginateData = () => {
    const startIndex = (currentPage - 1) * entriesPerPage;
    const endIndex = startIndex + entriesPerPage;
    return stockData.slice(startIndex, endIndex).map((item, index) => ({
      ...item,
      serial: startIndex + index + 1, // Continuous serial number calculation
    }));
  };
  
  const totalPages = Math.ceil(stockData ? stockData.length / entriesPerPage : 0);

  return (
    
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
           {/* Content wrapper */}
           <div className="d-flex flex-column flex-column-fluid">
               {/* Toolbar */}
               <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                   {/* Toolbar container */}
                   <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                       {/* Page title */}
                       <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                           {/* Title */}
                           <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                           Inventory Report
                           </h1>
                           <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                               <li className="breadcrumb-item text-muted">
                                   <a href="index.html" className="text-muted text-hover-primary">Home</a>
                               </li>
                               <li className="breadcrumb-item">
                                   <span className="bullet bg-gray-500 w-5px h-2px"></span>
                               </li>
                               <li className="breadcrumb-item text-muted">Dashboards</li>
                           </ul>
                       </div>
                   </div>
               </div>
         
               <div id="kt_app_content" className="app-content flex-column-fluid">
                   <div id="kt_app_content_container" className="app-container container-fluid">
                       <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                           <div className="col-xl-12">
                             
                                    <ToastContainer />
                               

  
                                   </div>
                                   <div className="card-body ">


                                    
                                       <div className="table-responsive">
                                           <div className="panel-body">
{/*                                             
                                           <button
  onClick={exportToExcel}
  className="btn btn-success"
  style={{ marginBottom: '20px' }}
  disabled={!stockData || stockData.length === 0}
>
  Export to Excel
</button> */}
 
 
 
                    
                                           <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12">
                                           <form onSubmit={handleSubmit} style={{ marginBottom: '20px' }}>
  <div className="form-group row align-items-center">
    <div className="col-lg-2 col-6">
      <label htmlFor="fromDate" className="form-label">
        From Date:
      </label>
      <input
                            type="date"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                          />
    </div>
    <div className="col-lg-2 col-6">
      <label htmlFor="toDate" className="form-label">
        To Date:
      </label>
      <input
                            type="date"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
    </div>
    <div className="col-lg-2 col-6">
      <label htmlFor="language" className="form-label">
        Language:
      </label>
   

      <select
                            className="form-control"  id="language"
                            value={language}
                            onChange={(e) => setLanguage(e.target.value)}
                          >
                            <option value="English">English</option>
                            <option value="Desi">Desi</option>
                          </select>





    </div>
    <div className="col-lg-2 col-12 mt-3">
      <button type="submit" className="btn btn-primary mt-5">
        +GETDATA
      </button>
    </div>
    <div className="col-lg-2 col-6">
      <label htmlFor="entriesPerPage" className="form-label">
        Entries per page:
      </label>
      <select
                            className="form-control"
                            value={entriesPerPage}
                            onChange={handleEntriesPerPageChange}
                          >
        <option>10</option>
        <option>20</option>
        <option>50</option>
        <option>100</option>
      </select>
    </div>
   
  </div>
  </form>
</div>
                                               <div className="clearfix"></div>
                                               <br />
                                               {error && <p style={{ color: "red" }}>Failed to fetch data.</p>}
 
 {stockData === null && !loading && (
   <div style={{ textAlign: 'Left', fontSize: '18px', fontWeight: 'bold' }}>
    
   </div>
 )}
 
 {!loading && stockData && stockData.length === 0 && <EmptyState />}
 
 {!loading && stockData && stockData.length > 0 && (
   <div>
      
             <div className="table-responsive mt-4 h-400px">
         
             <table className="table table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                       
                              <th>Product Name</th>
                             
                                {/* <th>price</th> */}
                                <th>Packing</th>
                                <th>Opening Balance</th>
                                 <th>Received</th>
                                 <th>Transfer</th>
                                  <th>Total</th>
                                  <th>Closing Stock</th>
                                   <th>Sales</th>
                                   <th>Rate</th>
                                  <th>Amount</th>
                                 
                            </tr>
                          </thead>
                          <tbody>
{paginateData().map((item, index) => (
  <tr key={index}>
    <td>{item.serial}</td> {/* Continuous S.No. */}
    <td>{item.pName || "N/A"}</td>
    {/* <td>{item.mrp}</td> */}
    <td>{item.packing}</td>
    <td>{item.openingStock || 0}</td>
    <td>{item.rece || 0}</td>
    <td>{item.trans}</td>
    <td>{(item.openingStock || 0) + (item.rece || 0) - (item.trans || 0)}</td>
    <td>{item.closingStock || 0}</td>
    <td>{item.sales || 0}</td>
    <td>{item.mrp}</td>
    <td>{(item.sales || 0) * (item.mrp || 0)}</td>

  </tr>
))}
</tbody>
       
                          <tfoot>
<tr>
  <td colSpan="3"><strong>Total</strong></td>
  <td ><strong>{stockData.reduce((sum, item) => sum + (item.openingStock || 0), 0)}</strong></td>
  <td ><strong>{stockData.reduce((sum, item) => sum + (item.rece || 0), 0)}</strong></td>
  <td ><strong>{stockData.reduce((sum, item) => sum + (item.trans || 0), 0)}</strong></td>
  <td ><strong>{stockData.reduce((sum, item) => sum + ((item.openingStock || 0) + (item.rece || 0) - (item.trans || 0)), 0)}</strong></td>
  <td ><strong>{stockData.reduce((sum, item) => sum + (item.closingStock || 0), 0)}</strong></td>
  
  <td ><strong>{stockData.reduce((sum, item) => sum + (item.sales || 0), 0)}</strong></td>
  <td>
  <strong>
    {stockData.reduce((sum, item) => sum + (item.mrp || 0), 0).toLocaleString()}
  </strong>
</td>
  
  <td ><strong>₹ {stockData.reduce((sum, item) => sum + ((item.sales || 0) * (item.mrp || 0)), 0)}</strong></td>
</tr>
</tfoot>

                        </table>
    
     </div>
     
                                    
       <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
     <div>
                           <button
                             onClick={() => setCurrentPage(currentPage - 1)}
                             disabled={currentPage === 1}
                           >
                             Previous
                           </button>
                           <span>
                             Page {currentPage} of {totalPages}
                           </span>
                           <button
                             onClick={() => setCurrentPage(currentPage + 1)}
                             disabled={currentPage === totalPages}
                           >
                             Next
                           </button>




  





                         </div>
                                                                        <button
  onClick={exportToExcel}
  className="btn btn-success"
  style={{ marginBottom: '20px' }}
  disabled={!stockData || stockData.length === 0}
>
  Export to Excel
</button>
       
</div>
   
                                 {/* OTP Input */}
  
  
     
                              
    
        
       
       
                                                 
                                           </div>
                                                )}
                                           
                                       </div>
                                   </div>
                               </div>
                          
                     
                   </div>
               </div>
           </div>
         
           {/* Footer */}
           <div id="kt_app_footer" className="app-footer">
               <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
                   <div className="text-gray-900 order-2 order-md-1">
                       <span className="text-muted fw-semibold me-1">2025&copy;</span>
                       <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
                   </div>
               </div>
           </div>
       
         
         
         
         
         
         
         
     
         
        
         
         
         
         
         
        
         
       
         </div>
         </div>
  );
};

export default StockManagementReport;



